import { render, staticRenderFns } from "./CreateCustomerGroupWithNumbers.vue?vue&type=template&id=2bdcf02a"
import script from "./CreateCustomerGroupWithNumbers.vue?vue&type=script&lang=js"
export * from "./CreateCustomerGroupWithNumbers.vue?vue&type=script&lang=js"
import style0 from "./CreateCustomerGroupWithNumbers.vue?vue&type=style&index=0&id=2bdcf02a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports